import {
  AtlasBodyTitle,
  AtlasColor,
  AtlasH1,
  AtlasH2,
  SnackbarInformationPanel
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { useEffect } from 'react'
import styled from 'styled-components'
import { useScanner } from 'hooks/scanner.hook'

interface ScannerProps {
  label?: string
  gap?: number
  mode?: 'default' | 'card' | 'hidden'
  cardHeight?: number
  onScan: (scanned: string) => void
}

const ScannerContainer = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  gap: ${({ $gap }) => $gap ?? 32}px;
`

export const ScannerMolecule = (props: ScannerProps) => {
  const { keys, getScan } = useScanner()
  const { label, onScan, mode = 'default', gap, cardHeight } = props

  useEffect(() => {
    const scanned = getScan()
    if (scanned) {
      console.info('scanned from ScannerMolecule', scanned)
      onScan(scanned)
    }
  }, [getScan, keys, onScan])

  return (
    <>
      {mode === 'card' ? (
        <SnackbarInformationPanel
          style={{
            border: '1px solid',
            borderRadius: '12px',
            backgroundColor: AtlasColor.Primary10,
            borderColor: AtlasColor.Important,
            alignItems: 'center',
            height: cardHeight
          }}
        >
          <Icon name="ic_scan" size={40} color={AtlasColor.Primary} />
          <AtlasBodyTitle>{label}</AtlasBodyTitle>
        </SnackbarInformationPanel>
      ) : mode === 'default' ? (
        <ScannerContainer $gap={gap}>
          <AtlasH2>Escanea</AtlasH2>
          <AtlasH1 style={{ textAlign: 'center' }}>{label}</AtlasH1>
        </ScannerContainer>
      ) : null}
    </>
  )
}
